<template>
  <div class="hsec">
    <div class="row top">
      <div class="col header-text">
        <div class="pre-header"></div>
        <h1>{{ $t('views.security.securityAnd') }}<span class="blue">{{ $t('views.security.safety') }}</span></h1>
        <h3><p>{{ $t('views.security.investingIsUltimately') }}</p>
          <p>{{ $t('views.security.weHaveCreated') }}</p></h3>
      </div>
      <div class="col top-block">
      </div>
    </div>

    <div class="container risk-solution">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <div class="risk-box">
                <h2>{{ $t('views.security.theKeyRisks') }}</h2>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 d-none d-sm-none d-md-block">
              <div class="risk-box">
                <h2>{{ $t('views.security.theSolutions') }}</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <div class="risk-box">
                <div class="title">{{ $t('views.security.riskOfBorrower') }}</div>
                <div class="desc"><p>{{ $t('views.security.theRiskIs') }}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 d-none d-sm-none d-md-block">
              <div class="risk-box">
                <div class="title">{{ $t('views.security.buybackGuarantee') }}</div>
                <div class="desc"><p>{{ $t('views.security.allLoansCome') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
              <div class="risk-box">
                <div class="title">{{ $t('views.security.riskOfLo') }}</div>
                <div class="desc"><p>{{ $t('views.security.theRiskThat') }}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-6 d-none d-sm-none d-md-block">
              <div class="risk-box">
                <div class="title">{{ $t('views.security.cashflowBuffer') }}</div>
                <div class="desc"><p>{{ $t('views.security.whenALoan') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ONLY FOR MOBILES -->
        <div class="d-block d-sm-block d-md-none">
          <div class="col-lg-12">
            <div class="risk-box mobile">
              <h2>{{ $t('views.security.theSolutions1') }}</h2>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <div class="risk-box">
                  <div class="title">{{ $t('views.security.buybackGuarantee1') }}</div>
                  <div class="desc"><p>{{ $t('views.security.allLoansCome1') }}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <div class="risk-box">
                  <div class="title">{{ $t('views.security.cashflowBuffer1') }}</div>
                  <div class="desc"><p>{{ $t('views.security.whenALoan1') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-12 black-box">
            <div class="wtext">{{ $t('views.security.thereIsAlways') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <img :src="getSrc('security_in_detail.jpg')" alt="" class="w-100">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="equal-opportunity">
            <div class="row">
              <div class="col-12 col-md-5 col-lg-5 col-xl-5 ">
                <div class="bg-column">
                  <div class="circle">{{ $t('views.security.theCashflow') }}<br/>{{ $t('views.security.buffer') }}<br/>{{ $t('views.security.inDetail') }}</div>
                </div>
              </div>
              <div class="col-12 col-md-7 col-lg-7 col-xl-7 text">
                <div class="info">{{ $t('views.security.thisBufferIs') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container other-risks">
      <div class="row">
        <div class="col-lg-12">
          <h2>{{ $t('views.security.otherInvestmentRisks') }}</h2>
          <h3>{{ $t('views.security.platformRisk') }}</h3>
          <p>{{ $t('views.security.inTheUnlikely') }}</p>
          <h3>{{ $t('views.security.marketRisk') }}</h3>
          <p>{{ $t('views.security.asWithAny') }}</p>
          <h3>{{ $t('views.security.regulatory_ComplianceRisk') }}</h3>
          <p>{{ $t('views.security.theRiskOf') }}</p>
          <h3>{{ $t('views.security.reinvestmentRisk') }}</h3>
          <p>{{ $t('views.security.theRiskOf1') }}</p>
          <h3>{{ $t('views.security.liquidityRisk') }}</h3>
          <p>{{ $t('views.security.theRiskOf2') }}</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="home-start-investing">
            <h2>{{ $t('views.security.startInvestingToday') }}</h2>
            <div class="detail-info">{{ $t('views.security.earnUpTo') }}</div>
            <get-started/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetStarted from '../components/GetStarted'
import imageMixin from '../mixins/image'

export default {
  name: 'Security',
  components: {
    GetStarted
  },
  mixins: [imageMixin]
}
</script>

<style scoped lang="scss">

.hsec {
  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }
}

.header-text {
  text-align: left;
  margin: 82px auto 16px 10%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 70px;
    text-align: left;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;

    .blue {
      color: #30A7FE;
    }
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: left;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 0 10px;
  }
}

.ensuring-fairness {
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;

  h2 {
    margin-top: 50px;
    margin-bottom: 16px;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
  }

  img {
    max-width: 642px;
    width: 100%;
    margin-bottom: 35px;
  }
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}

.equal-opportunity {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;

  .bg-column {
    background-image: url("../assets/equal-opportunity.png");
    background-position: left 0;
    background-repeat: no-repeat;
    background-size: contain;
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%;
    display: inline-block;
  }

  .text {
    margin-top: 100px;
    margin-bottom: 100px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin: 0 16px;
    }

    .info {
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 24px;
      color: #6E777A;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 0 16px;
    }
  }

  .circle {
    background: #EC4C60;
    border-radius: 108px;
    border: 3px solid #EC4C60;
    font-weight: bold;
    text-align: center;
    color: #FFFFFF;
    font-style: normal;
    padding-top: 61px;
    padding-bottom: 61px;
    margin: 19% 0 0 41%;
    font-size: 22px;
    line-height: 30px;
    max-width: 220px;
  }
}

.top-block {
  background-image: url("../assets/security-top-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.black-box {
  background: #000000;
  margin: 24px 0;
  padding: 25px;
  min-height: 220px;
  width: 100%;
  display: inline-block;
  text-align: center;

  .wtext {
    color: white;
    margin-top: 65px;
    margin-bottom: 55px;
    text-align: center;
    max-width: 1110px;
    font-size: 19px;
    width: 100%;
    display: inline-block;
  }

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: #FFFFFF;
    margin-bottom: 10px;
    text-align: center;
  }

  .desc {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #6E777A;
  }
}

.risk-box {
  margin: 5px;
  padding: 5px;

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    align-items: center;
    color: #000000;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin: 36px 0;
    border-bottom: 1px solid #6E777A;
  }

  .desc {
    font-size: 16px;
    line-height: 24px;
    color: #6E777A;
  }
}

.info-img {
  text-align: center;
  width: 100%;

  img {
    max-width: 100px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .top-block {
    display: none;
  }
}

@media only screen and (max-width: 1024px) {

  .equal-opportunity {

    .bg-column {
    }

    .text {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .circle {
      margin: 10% 0 56px 26%;
    }
  }
}

.risk-solution {
  margin-top: 65px;
  margin-bottom: 25px;

  .risk-box {
    h2 {
      font-weight: bold;
    }
  }
}

@media (max-width: 375px) {
  .equal-opportunity {
    .circle {
      margin: 25% 0 60px 30%;
    }
  }
}

.other-risks {
  h2 {
    font-weight: bold;
    margin-bottom: 45px;
    margin-top: 35px;
    @media (max-width: 768px) {
      font-size: 55px;
      line-height: normal;
    }
  }

  h3 {
    font-weight: bold;
    margin-top: 25px;
  }

  p {
    text-align: justify;
  }
}

.mobile {
  margin-top: 25px;
  margin-bottom: 0;
}
</style>
